import { Component } from '@nicolas-riciotti/light2'

function loadThirdPartyScript(scriptId, scriptSrc, callback) {
  const js   = document.createElement('script')
  const head = document.head || document.getElementsByTagName('head')[0]
  js.id    = scriptId
  js.src   = scriptSrc
  js.async = false
  js.addEventListener('load', callback, false)
  head.insertBefore(js, head.firstChild)
}
 

let coreVideoId = 0;

export default class CoreVideo extends Component {

  created() {
    this.isPlaying               = false;
    this.videoSrc                = null;
    this.videoType               = null;
    this.togglePlay              = this.togglePlay.bind(this);
    this.onCloudflarePlayerReady = this.onCloudflarePlayerReady.bind(this);
    this.onYoutubeAPIReady       = this.onYoutubeAPIReady.bind(this);
    this.onYoutubePlayerReady    = this.onYoutubePlayerReady.bind(this);
    this.onHTMLVideoPlayerReady  = this.onHTMLVideoPlayerReady.bind(this);
    this.checkReady              = this.checkReady.bind(this)
    this.reducedMotion           = localStorage['accessibility'] === 'true';
    this.videoId = coreVideoId++;

    this.onPlayerMouseMove       = this.onPlayerMouseMove.bind(this);
    this.startControlsTimer      = this.startControlsTimer.bind(this);
    this.clearControlsTimer      = this.clearControlsTimer.bind(this);

    this.controlsHideDelay = 2000;
    this.controlsTimer = null;

  }

  onYoutubeAPIReady(event) {
    
    document.removeEventListener('youtubeAPIRready', this.onYoutubeAPIReady);

    this.player = new YT.Player(this.$video.id, {
      videoId: this.youtubeID,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        origin: window.location.host,
        'playsinline': 1,
        'autoplay': !this.reducedMotion  && this.autoplay ? 1 : 0,
        'modestbranding': 1,
        'rel': 0,
        'enablejsapi': 1
      },
      events: {
        'onAutoplayBlocked': e => {
          console.log('AUTOPLAY BLOCKEDE', e)
        },
        'onStateChange': (event)=>{
          if (event.data == YT.PlayerState.PLAYING) {
            this.isPlaying = true;
            this.toggleVideo('play');
          }
        },
        'onReady': this.onYoutubePlayerReady,
      }
    })
  }

  attached() {

    this.autoplay  = this.hasAttribute('autoplay')
    this.autoplayOnView  = this.hasAttribute('autoplay-on-view')
    this.muted  = this.hasAttribute('muted')
    this.videoType = this.getAttribute('type') || 'file';
    const attrSrc  = this.getAttribute('src');
    
    this.videoAltText  = this.getAttribute('data-alt') || '';

    this.$videoWrapper   = this.querySelector('[data-video-container]');
    if (this.videoType == 'youtube') {
      this.youtubeID = attrSrc;
      this.$videoWrapper.innerHTML = `<div  data-video style="width:100%; height: 100%; " id="video-player-${this.videoId}"></div>`;
    }
    else if (this.videoType == 'cloudflare') {
      this.videoSrc = 'https://customer-cwj7wuunq08v7vjo.cloudflarestream.com/'  + attrSrc + '/iframe?autoplay=true';
      this.$videoWrapper.innerHTML = `<iframe style="width:100%; height: 100%; " data-video autoplay playsinline preload src="${this.videoSrc}" id="video-player-${this.videoId}"></iframe>`;
    }
    else {
      this.videoSrc = attrSrc;
      this.videoDescriptionID = 'core-video-description-' + this.videoId;
      this.videoProgressID    = 'core-video-progress-' + this.videoId;
      this.$videoWrapper.innerHTML = `
        <video
          style="width:100%; height: 100%; object-fit: cover;"
          data-video
          loop
          preload="${this.autoplayOnView ? 'auto' : 'none'}"
          playsinline
          ${!this.reducedMotion && this.autoplay?'autoplay':''}
          ${this.muted ? 'muted' : ''}
          src="${this.videoSrc}"
        ></video>
        <div id="${this.videoDescriptionID}" class="sr-only">
          ${ this.videoAltText }
        </div>
      `;
      // <div id="${this.videoProgressID}" class="sr-only" data-video-progress aria-live="polite" aria-atomic="true" ></div>
    }

    // this.shadowRoot.innerHTML = `
    //   <style>${CSS}</style>
    //   ${$media}
    //   <slot name="poster"></slot>
    //   <slot name="play-button"></slot>
    //   <slot name="progress-bar"></slot>
    // `;

    this.$video   = this.querySelector('[data-video]');
    this.$poster  = this.querySelector('[data-poster');

    this.$playBtn = this.querySelector('[data-play-button]');
    
    if (this.videoType != 'youtube' && this.videoType != 'cloudflare') {
      this.$video.setAttribute('aria-describedby', this.videoDescriptionID || ''); 
    }

    this.$playNav = this.querySelector('[data-play-nav]');

    this.$videoProgress   = this.querySelector('[data-video-progress]');

    this.addEventListener('click', this.togglePlay)
    this.checkReady();

    if (this.autoplayOnView) {
      this._inView = false;
      this._io = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          this._inView = entry.isIntersecting;
          if (entry.isIntersecting) {
            if (this.isReady && !this.isPlaying) {
              this.isPlaying = true;
              this.toggleVideo('play');
            }
          } else if (this.isPlaying) {
            this.isPlaying = false;
            this.toggleVideo('pause');
          }
        }
      }, { rootMargin: '100px 0px' });
      this._io.observe(this);
    }


    this.addEventListener('mouseenter', this.onPlayerMouseMove);
    this.addEventListener('mousemove', this.onPlayerMouseMove);
    
  }

  onPlayerMouseMove() {
    console.log('onPlayerMouseMove')
    if (!this.isPlaying) return;
    this.classList.remove('hide-controls');
    this.startControlsTimer();
  }

  startControlsTimer() {
    // Autoplay-on-view videos use the small bottom-right control — keep it
    // visible so users always know they can pause, and so touch devices
    // (which have no hover) don't lose the affordance.
    if (this.autoplayOnView) return;
    this.clearControlsTimer();
    this.controlsTimer = setTimeout(() => {
      if (this.isPlaying) {
        this.classList.add('hide-controls');
      }
    }, this.controlsHideDelay);
  }

  clearControlsTimer() {
    clearTimeout(this.controlsTimer);
    this.controlsTimer = null;
    this.classList.remove('hide-controls');
  }

  detached() {
    this.removeEventListener('click', this.togglePlay)
    this?.removeEventListener('mouseenter', this.onPlayerMouseMove)
    this?.removeEventListener('mousemove', this.onPlayerMouseMove)
    this.clearControlsTimer()
  }
  
  checkReady() {

    if (this.videoType == 'cloudflare') {
      if (null === document.getElementById('app_cloudflare_video-js')) {
        loadThirdPartyScript('app_cloudflare_video-js', 'https://embed.cloudflarestream.com/embed/sdk.latest.js', this.checkReady)
        return
      }
      this.player = window.Stream(this.$video)
      this.player.addEventListener('canplay', this.onCloudflarePlayerReady, false)
    } 
    else if (this.videoType == 'youtube') {
      if (null === document.getElementById('app_youtube_video-js')) {
        loadThirdPartyScript('app_youtube_video-js', 'https://www.youtube.com/iframe_api', this.checkReady)
        // return
      }
      document.addEventListener('youtubeAPIRready', this.onYoutubeAPIReady, false)
    } 
    else {//if (this.videoType == 'file') {

      this.$video.addEventListener('play', ()=> {
        this.isPlaying = true;
        this.toggleVideo('play');
      });

      if (this.$video.readyState >= 1) {
        this.duration = this.$video.duration
        this.onVideoReady()
      } else {
        this.$video.addEventListener('canplay', this.onHTMLVideoPlayerReady, false)
      }
    } 
  }
  toggleVideo(action) {

    if (this.videoType === 'youtube') {
      this.player[`${action}Video`]()
      const $iframe = this.querySelector('iframe');
      $iframe.removeAttribute('aria-hidden', 'true');
      $iframe.removeAttribute('tabindex', '-1');
      if (action === 'play  ') {
        $iframe.focus();
        console.log('FOCUS IFRAME');
      }
    } 
    else if (this.videoType === 'cloudflare') {
      this.player[action]()
    } 
    else {//if (this.videoType === 'file') {
      this.$video[action]()
    }
    
    if (this.$playBtn) {
      // this.$playBtn.ariaPressed =  ('play' === action) ? 'true' : 'false' ;
      let playLabel = this.$playBtn.getAttribute('data-aria-play-label') || 'play video';
      let pauseLabel = this.$playBtn.getAttribute('data-aria-pause-label') || 'pause video';
      this.$playBtn.setAttribute('aria-label', ('play' === action) ? pauseLabel : playLabel);
      this.$playBtn.setAttribute('title', ('play' === action) ? pauseLabel : playLabel);
    }

    if (this.$poster) {
      if ('play' === action) {
        // this.$poster.style.display = ('play' === action) ? 'none' : 'block';
        this.$poster.style.display  = 'none';
        const $iframe = this.querySelector('iframe');
        $iframe?.focus();
        console.log('FOCUS IFRAME');
      }
    }

    if (this.$playNav) {
      if (this.videoType === 'youtube') {
        if ('play' === action) {
          this.$playNav.style.display  = 'none';
        }
      }
    }

    if ('play' === action) {
      this.classList.add('is-playing');
      this.classList.remove('is-paused');
      this.startControlsTimer();
    }
    else {
      this.classList.add('is-paused');
      this.classList.remove('is-playing');
      this.clearControlsTimer();
    }

  }
  
  onCloudflarePlayerReady(event) {
    this.player.removeEventListener('canplay', this.onCloudflarePlayerReady)
    this.duration = this.player.duration
    this.onVideoReady();
  }

  onYoutubePlayerReady(event) {
    const $iframe = this.querySelector('iframe');
    if ($iframe) {
      $iframe.setAttribute('aria-hidden', 'true');
      $iframe.setAttribute('tabindex', '-1');
      this.duration = this.player.getDuration()
      this.onVideoReady();
    }
    else {
      console.log('IFRAME IS NOT READY');
    }
  }

  onHTMLVideoPlayerReady(event) {
    this.$video.removeEventListener('canplay', this.onHTMLVideoPlayerReady)
    this.duration = this.$video.duration;
    this.onVideoReady(); 
  }
  
  onVideoReady() {
    this.isReady = true
    if (this.autoplay && this.videoType !== 'youtube') {
      this.isPlaying = true;
      this.toggleVideo('play');
    }
    if (this.autoplayOnView && this._inView && !this.isPlaying && this.videoType !== 'youtube') {
      this.isPlaying = true;
      this.toggleVideo('play');
    }
  }

  togglePlay(event) {
    this.isPlaying = !this.isPlaying;
    this.toggleVideo(this.isPlaying ? 'play' : 'pause')
  }
  
  getCurrentTime() {
    if (this.videoType == 'cloudflare') {
      return this.player.currentTime;
    } 
    else if (this.videoType == 'youtube') {
      return this.player.getCurrentTime();
    }
    return this.$video.currentTime;
  }

  update() {
    if (this.isReady) {
      const progress = this.getCurrentTime() / this.duration
      this.style.setProperty('--video-progress', progress);
      if (this.$videoProgress) {
        this.$videoProgress.textContent = `Video is at ${Math.floor(this.getCurrentTime())} seconds.`;
      }
    }
  }

}

customElements.define('core-video', CoreVideo)